export class Attributes {
    constructor(
        public given_name: string,
        public family_name: string,
        public locale: string,
    ) { }
}
